import {SearchItem, SearchResultDto} from "./search-table.dto.res";
import {OrgUserDto} from "../org-user.dto";

export class SearchOrgUserRes extends SearchResultDto {

  public override readonly items: SearchOrgUserItem[] = [];

  constructor(init?: Partial<SearchOrgUserRes>) {
    super(init);
    if (init?.items) {
      this.items = init.items.map((i) => new SearchOrgUserItem(i));
    } else {
      this.items = [];
    }
  }
}

export class SearchOrgUserItem extends OrgUserDto implements SearchItem {

  constructor(init?: Partial<SearchOrgUserItem>) {
    super(init);
    Object.assign(this, init);
  }
}
